import React, {useEffect, useState} from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {useParams} from 'react-router-dom';
import {baseUrl, formatDateTime, ipAddress, userLocation, userName} from '../../Univ.js'
function Respirate(props) {
    const {ip_id} = useParams();
    const [ipData, setIpData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [respData, setrespData] = useState([]);
    const [nurseData, setnurseData] = useState({
        "ip": '',
        "rate": '',
        "variation": '',
        "pattern": '',
        "trachestomy": '',
        "secretion": '',
        "sweat": '',
        "suction": '',
        "notes": '',
        "resp_time": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };
    useEffect(() => {
        fetchrespData();
    }, []);
    function fetchrespData() {
        axios.get(baseUrl + "view-resp/" + ip_id + "/")
            .then(response => {
                setrespData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const formSubmit = (e) => {
        e.preventDefault();
        const rate = document.getElementById("rate").value;
        const variation = document.getElementById("variation").value;
        const pattern = document.getElementById("pattern").value;
        const trachestomy = document.getElementById("trachestomy").value;
        const secretion = document.getElementById("secretion").value;
        const sweat = document.getElementById("sweat").value;
        const suction = document.getElementById("suction").value;
        const notes = document.getElementById("notes").value;
        const resp_time = document.getElementById("resp_time").value;
        const _formData = new FormData();
        _formData.append('ip', ip_id);
        _formData.append('rate', rate);
        _formData.append('variation', variation);
        _formData.append('pattern', pattern);
        _formData.append('trachestomy', trachestomy);
        _formData.append('secretion', secretion);
        _formData.append('sweat', sweat);
        _formData.append('suction', suction);
        _formData.append('notes', notes);
        _formData.append('resp_time', resp_time);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        axios.post(`${baseUrl}resp-create/`, _formData)
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'resp Details Updated Succesfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setnurseData({
                        ip: '',
                        notes: '',
                        resp_time: '',
                        status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/nurse-pat-view/' + ip_id + '/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed. Please try again later.',
                    'error'
                );
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-resp/' + id + '/')
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                        });
                    setTimeout(() => {
                        window.location.href = ('/respirate/' + ip_id + '/');
                    }, 2000);
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                Primary Consultant - Dr.{ipData.map(row => row.primary_consult.consultant)}
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>IP ID</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (
                        <tr>
                            <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail"
                                     style={{width: 120, height: 60}}/></td>
                            <td>{patientData.ip_id}</td>
                            <td>{patientData.pat.pat_id}</td>
                            <td>{patientData.pat.patient}</td>
                            <td>{patientData.pat.gender}</td>
                            <td>{patientData.pat.age}</td>
                            <td>{patientData.pat.mobile}</td>
                            <td>{formatDateTime(patientData.admit_date)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div>
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-lungs" aria-hidden="true" style={{color: 'red'}}></i>
                    Respiration System Details
                </h3>
                <form>
                    <div className="row">
                        <div className="col-md-2">
                            <label htmlFor="" className="form-label">Rate : </label>
                            <input
                                type="text"
                                className="ms-1 form-control"
                                name="rate"
                                id="rate"
                            />
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Rate Variation: </label>
                            <select className="form-control"
                                    name="variation" id="variation">
                                <option>Select</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Pattern: </label>
                            <select className="form-control"
                                    name="pattern" id="pattern">
                                <option>Select</option>
                                <option value="Shallow">Shallow</option>
                                <option value="Deep Breath">Deep Breath</option>
                                <option value="Aceidotic">Aceidotic</option>
                                <option value="Trachypnoea">Trachypnoea</option>
                                <option value="Jaw Breath">Jaw Breath</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Trachestomy: </label>
                            <select className="form-control"
                                    name="trachestomy" id="trachestomy">
                                <option>Select</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Lot of secretion: </label>
                            <select className="form-control"
                                    name="secretion" id="secretion">
                                <option>Select</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Minimal Sweating: </label>
                            <select className="form-control"
                                    name="sweat" id="sweat">
                                <option>Select</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Secretion needs <br/>
                                frequent suctioning: </label>
                            <select className="form-control"
                                    name="suction" id="suction">
                                <option>Select</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Notes" className="form-label">Notes : </label>
                            <textarea
                                className="no-comma form-control"
                                tabIndex="0"
                                name="notes"
                                id="notes"
                            ></textarea>
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
                            <DatePicker className="form-control" name="resp_time" id="resp_time"
                                        selected={selectedDateTime}
                                        onChange={handleDateTimeChange}
                                        dateFormat="yyyy-MM-dd h:mm"
                                        showTimeSelect
                                        timeIntervals={15}
                                        timeCaption="Time"
                            />
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='ms-5 mb-5'>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
                    </div>
                </form>
                <div className="card card-body">
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                        <i className="fa-solid fa-lungs" aria-hidden="true" style={{color: 'red'}}></i>
                        Respiration System History
                    </h3>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Date</th>
                                <th colSpan="8">Respiration Details</th>
                                <th>Delete</th>
                            </tr>
                            </thead>
                            <tbody>
                            {respData.map((dis, index) => (
                                <tr>
                                    <td>{formatDateTime(dis.resp_time)}</td>
                                    <td>Rate : {dis.rate}</td>
                                    <td>Rate Variation : {dis.variation}</td>
                                    <td>Pattern: {dis.pattern}</td>
                                    <td>Trachestomy : {dis.trachestomy}</td>
                                    <td>Lot of secretion : {dis.secretion}</td>
                                    <td>Minimal Sweating : {dis.sweat}</td>
                                    <td>Secretion needs
                                        <br/>frequent suctioning : {dis.suction}</td>
                                    <td>Notes : {dis.notes}</td>
                                    <td>
                                        <button className="btn btn-danger" type="button"
                                                onClick={() => handleDelete(dis.id)}>
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Respirate;